import React from "react";
import Grid from "@mui/material/Grid";
import { headCellsResponsive } from "./handler";
import { UpdatePopup } from "./";
import styled from "@mui/material/styles/styled";
const StyleGridBodyWrapper = styled(Grid)(({ theme }) => {
    return {
        borderBottom: "1px solid rgba(0, 0, 0, .125)",
        padding: 10,
        marginTop: 10,
        ".status_field": {
            marginTop: "5px !important",
            position: "absolute",
            transform: "translateY(0px)",
        },
        ".reimbursement_details": {
            fontFamily: "Roboto",
            fontWeight: 500,
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: "normal",
            letterSpacing: ".88px",
            textAlign: "left",
            color: "#454d58",
        },
        "#reimbursement_label": {
            fontSize: 11,
        },
        "#reimbursement_value": {
            margin: 0,
            fontSize: 14,
        },
        td: {
            border: 0,
            paddingTop: 5,
            button: {
                padding: 0,
            },
        },
    };
});
const MyReimbursementResponsive = ({ actionHandler, row }) => {
    return (React.createElement(StyleGridBodyWrapper, { container: true, spacing: 2, id: "my-reimbursement_responsive" }, headCellsResponsive.map(({ label, grid, id }) => {
        const value = row[id];
        const isSubmitted = row[id] === "NOT YET SUBMITTED"
            ? "status-field_pending"
            : "status-field_submitted";
        return (React.createElement(Grid, Object.assign({ item: true }, grid, { key: label, sx: { paddingTop: "0 !important" } }), label !== "action" ? (React.createElement(React.Fragment, null,
            label ? (React.createElement("p", { className: "reimbursement_details", id: "reimbursement_label", style: { marginBottom: 0 } }, label)) : null,
            React.createElement("p", { className: "reimbursement_details", id: "reimbursement_value" },
                React.createElement("span", { className: `${id === "status" ? "status_field " + isSubmitted : ""}` }, value)))) : (React.createElement(Grid, Object.assign({ item: true }, grid, { key: label }),
            React.createElement(UpdatePopup, { update: actionHandler(row) })))));
    })));
};
export default MyReimbursementResponsive;
